import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, tap, map } from 'rxjs/operators';
import { QuickSearchResults } from '../../../shared/entities/QuickSearchResults';
import { environment } from '../../../../environments/environment';
import { LotList } from '../../../shared/entities/LotList'; 
import { UpdateUserSettings } from '../../../shared/entities/UpdateUserSettings';
import { RevenueTypes } from '../../../shared/entities/RevenueTypes';
import { ActiveTaxList } from '../../../shared/entities/ActiveTaxList';


const GET_LOTS_FOR_USER = 'Lot/GetLotsByUserName';
const GET_CURRENT_DEFAULT_LOT_BY_USER_NAME = 'Lot/GetDefaultLotForUser';
const SET_CURRENT_DEFAULT_LOT_FOR_USER_NAME = 'Lot/UpdateUsersSelectedLotNumber';
const GET_REVENUE_TYPES_FOR_LOT_NUMBER = 'Lot/GetRevenueTypesByLotNumber';
const GET_ACTIVE_TAXES_BY_LOT_NUMBER = 'Lot/GetActiveTaxesByLotNumber';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  })
};

@Injectable()
  export class LotService {
  
    constructor(private http: HttpClient) {
    }


    getActiveTaxListByLotNumber(lotNumber: string): Observable<ActiveTaxList[]> {
      
        var endpoint = environment.RestServer + GET_ACTIVE_TAXES_BY_LOT_NUMBER + `?lotNumber=${lotNumber}`;

        return this.http.get<ActiveTaxList[]>(endpoint);
    }
   
    getActiveLostListByUserName(userName: string): Observable<LotList[]> {
    
        var endpoint = environment.RestServer + GET_LOTS_FOR_USER + `?userName=${userName}`;

        return this.http.get<LotList[]>(endpoint);
    }

    getCurrentDefaultLotForUser(userName: string): Observable<string> {
   
       var endpoint = environment.RestServer + GET_CURRENT_DEFAULT_LOT_BY_USER_NAME + `?userName=${userName}`;

        return this.http.get<string>(endpoint);
    }

    getRevenueTypesForLotNumber(lotNumber: string): Observable<RevenueTypes[]> {
     
        var endpoint = environment.RestServer + GET_REVENUE_TYPES_FOR_LOT_NUMBER + `?lotNumber=${lotNumber}`;

        return this.http.get<RevenueTypes[]>(endpoint);
    }

    setCurrentDefaultLotForUser(userSettings: UpdateUserSettings){

      const headers = {  };

     
      var endpoint = environment.RestServer + SET_CURRENT_DEFAULT_LOT_FOR_USER_NAME;


      this.http.put<any>(endpoint, userSettings, { headers }).subscribe(data => {
        
      });
    }
   
}




  
